import React, { Component } from 'react';
import {BrowserRouter, Routes, Route} from 'react-router-dom';

//import {BrowserRouter as Router} from 'react-router-dom';
import './App.css';
import {UserProvider} from './utils/usercontext';

//---- Home page
import Index from './routes/index';


class HomePage extends Component {
  render() {
    return (
      <div style={{height: "100%"}}>
        <UserProvider>
          <BrowserRouter>
            
            <Routes>
              {/*---- Error Pages */}
              
              <Route path="*" element={<Index />} />
            </Routes>

            
          </BrowserRouter>
        </UserProvider>
      </div>
    );
  }
};

export default HomePage;
